import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  clicked(url) {
    window.open(url, '_blank').focus()
  }
}
